import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.receptores.suggestions = {
      ...state.app.receptores.suggestions,
      busy: true,
      filters: {
        ...state.app.receptores.suggestions.filters,
        ...meta,
      },
      pagination: {
        ...state.app.receptores.suggestions.pagination,
        limit: meta.limit ?? 25,
      },
    };
  });

  const { filters, pagination } = store.state.app.receptores.suggestions;

  try {
    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      include: 'nomina',
    };

    const response = await Http.get('api/receptores', { params });

    store.setState((state) => {
      state.app.receptores.suggestions = {
        ...state.app.receptores.suggestions,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.receptores.suggestions.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.suggestions.busy = false;
      state.app.receptores.suggestions.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.receptores.suggestions = { ...initialState };
  });
};

const ReceptorSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default ReceptorSuggestionsStore;
